import { render, staticRenderFns } from "./Component-7.vue?vue&type=template&id=70b8e2f5&scoped=true&"
import script from "./Component-7.vue?vue&type=script&lang=js&"
export * from "./Component-7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b8e2f5",
  null
  
)

export default component.exports